export default __webpack_public_path__ + "images/386a03e3cce1e95360c20963618a1c1f.svg";